import React, { useState, useEffect } from "react";
import "./Cart.css";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import Coins from "../../../Components/Coins/Coins";
import Alert from "../../../Components/Alert/Alert";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { FiTrash2 } from "react-icons/fi";
import Loading from "../../../Components/Loading/Loading";
import BottomBar from "../../../Components/BottomBar/BottomBar";
import { MdMessage } from "react-icons/md";
import { useAuth } from "../../../AuthContext";
import Axios from "axios";
import useCart from "../../../Hooks/useCart";
import { Link, useNavigate } from "react-router-dom";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import { useBaseUrl } from "../../../ApiContext";
import { LazyLoadImage } from "react-lazy-load-image-component";


export default function ShoppingCart() {
  const navigate = useNavigate();
  const baseUrl = useBaseUrl();
  const { userToken } = useAuth();
  const { cart, setCart } = useCart(userToken);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const showAlertHandler = () => {
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
    setAlertText("به زودی");
  };

  useEffect(() => {
    if (cart !== null) {
      setIsLoading(false);
    }
    if (cart !== null && cart.cartitem_set.length === 0) {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
      setAlertText("موردی یافت نشد");
    }
  }, [cart]);

  const fetchCart = async () => {
    try {
      const response = await Axios.get(`${baseUrl}/cart`, {
        headers: {
          Authorization: `Token ${userToken}`,
        },
      });
      setCart(response.data);
    } catch (error) {
      console.log("Error during getting cart data", error);
    }
  };

  const handleRemoveProduct = async (event, cartProductId) => {
    event.stopPropagation();
    try {
      const response = await Axios.post(
        `${baseUrl}/cart/add_item`,
        { id: cartProductId, quantity: 0 },
        {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        }
      );
      console.log(response.data);
      fetchCart();
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
      setAlertText("از سبد خرید حذف شد");
    } catch (error) {
      console.log("Error during removing item to cart", error);
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
      setAlertText("خطا در برقراری ارتباط");
    }
  };

  const handleChangeQuantity = async (event, id, quantity, action) => {
    event.stopPropagation();
    const postData = {
      id: id,
      quantity: action === "add" ? quantity + 1 : quantity - 1,
    };
    try {
      const response = await Axios.post(`${baseUrl}/cart/add_item`, postData, {
        headers: {
          Authorization: `Token ${userToken}`,
        },
      });
      console.log(response.data);
      const updatedCartItem = response.data.data;
      console.log(updatedCartItem);
      fetchCart();
    } catch (error) {
      console.log("Error during adding item to cart", error);
    }
  };

  const handleOpenProduct = (item) => {
    navigate("/product", {
      state: {
        baseId: item.product.base_product_id,
        productId: item.product.id,
      },
    });
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay productContainer">
        <div className="pageWrapper cartOverlay">
          <div className="pageHeader horizontalBorder centeredFlex cartHeader">
            <div className="cartHeaderRight centeredFlex">
              <BackBtn />
              <Coins onShowAlert={showAlertHandler} />
            </div>
            <div className="cartHeaderLeft centeredFlex">
              <Link to="/tickets" className="contactSupport centeredFlex link">
                <p>ارتباط با پشتیبانی</p>
                <MdMessage className="messageIcon" />
              </Link>
              <img
                src="/images/ic_menu.svg"
                alt="menu"
                className="menuIcon"
                onClick={hamburgerMenuHandler}
              />
            </div>
          </div>
          {isLoading ? (
            <Loading />
          ) : (
            <div className="cartAddedItems scroll">
              {cart &&
                cart.cartitem_set.map((item) => (
                  <div
                    key={item.id}
                    className="cartProduct horizontalBorder"
                    onClick={() => handleOpenProduct(item)}
                  >
                    <div className="cartProductTop centeredFlex">
                      <div className="cartProductImgWrapper">
                        <LazyLoadImage
                          width="100%"
                          height="100%"
                          src={item.product.cover || "/images/bgLogo.svg"}
                          alt={item.product.title || "product"}
                          effect="opacity"
                          placeholderSrc="/images/bgLogo.svg"
                          style={{
                            borderRadius: "0.5rem",
                          }}
                          onError={({ target }) => {
                            target.onerror = null; 
                            target.src = "/images/bgLogo.svg"; 
                          }}
                        />
                      </div>
                      <div className="cartProductContent">
                        <div className="cartProductContentTop centeredFlex">
                          <p className="productTitle">{item.product.title}</p>
                          <div
                            className="trashBinWrapper centeredFlex"
                            onClick={(event) =>
                              handleRemoveProduct(event, item.product.id)
                            }
                          >
                            <FiTrash2 className="trashBin" />
                          </div>
                        </div>
                        <div className="cartProductPrice centeredFlex">
                          <div className="centeredFlex">
                            {item.product.price.toLocaleString()}
                          </div>
                          <p className="cartProductUnit">تومان</p>
                        </div>
                        <p className="cartPoductDetail">
                          {item.product.detail}
                        </p>
                      </div>
                    </div>
                    <div className="cartProductAttributes centeredFlex scroll">
                      {item.product.attributes.map((attribute) => (
                        <div key={attribute.value} className="productAttribute">
                          {attribute.name} : {attribute.value}
                        </div>
                      ))}
                    </div>
                    <div className="cartProductQuantityWrapper centeredFlex">
                      <div
                        className="changeQuantityBtn addQuantity centeredFlex"
                        onClick={(event) =>
                          handleChangeQuantity(
                            event,
                            item.product.id,
                            item.quantity,
                            "add"
                          )
                        }
                      >
                        <AddIcon className="quantityIcon" />
                      </div>
                      <div className="productQuantity centeredFlex">
                        {item.quantity}
                      </div>
                      <div
                        className="changeQuantityBtn minusQuantity centeredFlex"
                        onClick={(event) =>
                          handleChangeQuantity(
                            event,
                            item.product.id,
                            item.quantity,
                            "remove"
                          )
                        }
                      >
                        <RemoveIcon className="quantityIcon" />
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}
          <div className="cartBottom horizontalBorder centeredFlex">
            <div className="totalPrice centeredFlex">
              <p>مجموع سبد خرید</p>
              <p>{cart ? cart.total_price.toLocaleString() : "0"} تومان</p>
            </div>
            {!isLoading && cart.cartitem_set.length > 0 && (
              <Link
                to="/shopPayment"
                className="confirmAndNextBtn nextQuestion link"
              >
                تایید و مرحله بعد
              </Link>
            )}
          </div>
          <Alert alertText={alertText} showAlert={showAlert} />
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
